import { useEffect } from "react";
import FAQ from "../components/FAQ";
import FearGallery from "../components/FearGallery";
import Hero from "../components/Hero";
import MuseumIntro from "../components/MuseumIntro";
import SoftWarning from "../components/SoftWarning";

function Home() {
  useEffect(() => {
    if (window.location.hash !== "#gallery") {
      return;
    }

    const lastFear = sessionStorage.getItem("museum:lastFear");
    const target = lastFear ? document.getElementById(`fear-${lastFear}`) : document.getElementById("gallery");

    window.setTimeout(() => {
      target?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 80);
  }, []);

  return (
    <>
      <Hero />
      <SoftWarning />
      <MuseumIntro />
      <FearGallery />
      <FAQ />
    </>
  );
}

export default Home;
